import React from 'react';
import {
  BooleanField,
  BooleanInput,
  Create,
  DeleteWithConfirmButton,
  Edit,
  EditButton,
  Filter,
  ReferenceField,
  ReferenceInput,
  required,
  SearchInput,
  Show,
  TextField,
  TextInput,
} from 'react-admin';
import {
  ZippityDatagrid,
  ZippitySimpleForm,
  ZippitySimpleShow,
} from '../../components';
import LatLngField from '../LatLngField';
import { printCustomer } from '../customer';
import BulkDeleteButton from '../../components/BulkDeleteButton';
import CustomTitle from '../../components/CustomTitle';
import ReferenceChild from '../../components/ReferenceChild';
import { perPage } from '../../helper';
import TextFieldWithPrependAppend from '../TextFieldWithPrependAppend';
import ListWithCSVImport from '../../components/ListWithCSVImport';

export const CustomerAddressCreate = (props) => (
  <Create {...props}>
    <ZippitySimpleForm redirect="show">
      <ReferenceInput reference="customer" source="customer_id" linkType="show">
        <ReferenceChild {...props} optionText="email" source="customer_id" />
      </ReferenceInput>
      <TextInput source="address_line_1" validate={[required()]} />
      <TextInput source="address_line_2" />
      <TextInput source="city" validate={[required()]} />
      <TextInput source="state" validate={[required()]} />
      <TextInput source="postal_code" validate={[required()]} />
      <TextInput source="country" validate={[required()]} defaultValue="US" />
      <TextInput source="display_name" />
      <TextInput source="serviceability_note" />
      <BooleanInput source="is_deleted" />
      <BooleanInput source="is_primary" defaultValue />
    </ZippitySimpleForm>
  </Create>
);

export const CustomerAddressFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <ReferenceInput
      reference="customer"
      source="customer_id"
      perPage={perPage}
      alwaysOn
    >
      <ReferenceChild
        {...props}
        optionText={(choice) => printCustomer(choice)}
        source="customer_id"
      />
    </ReferenceInput>
  </Filter>
);

export const CustomerAddressList = (props) => (
  <ListWithCSVImport
    {...props}
    filters={<CustomerAddressFilter />}
    bulkActionButtons={<BulkDeleteButton />}
  >
    <ZippityDatagrid rowClick="show">
      <TextField source="created_at" />
      <TextField source="modified_at" />
      <TextField source="display_name" />
      <TextField source="customer_address_id" />
      <TextFieldWithPrependAppend source="tax_rate_percent" append="%" />
      <ReferenceField reference="customer" source="customer_id" link="show">
        <TextField source="email" />
      </ReferenceField>
      <TextField source="address_line_1" />
      <TextField source="address_line_2" />
      <TextField source="city" />
      <TextField source="state" />
      <TextField source="postal_code" />
      <TextField source="country" />
      <LatLngField source="lat-lng" prefix="" />
      <TextField source="serviceability_note" />
      <BooleanField source="is_deleted" />
      <BooleanField source="is_primary" />
      <EditButton />
      <DeleteWithConfirmButton />
    </ZippityDatagrid>
  </ListWithCSVImport>
);
export const CustomerAddressEdit = (props) => (
  <Edit
    undoable={false}
    title={
      <CustomTitle
        title="resources.customer-address.title"
        subTitle="resources.customer-address.subtitle"
      />
    }
    {...props}
  >
    <ZippitySimpleForm>
      <ReferenceInput reference="customer" source="customer_id" linkType="show">
        <ReferenceChild {...props} optionText="email" source="customer_id" />
      </ReferenceInput>
      <TextField source="tax_rate_percent" />
      <TextInput source="address_line_1" validate={[required()]} />
      <TextInput source="address_line_2" />
      <TextInput source="city" validate={[required()]} />
      <TextInput source="state" validate={[required()]} />
      <TextInput source="postal_code" validate={[required()]} />
      <TextInput source="country" validate={[required()]} defaultValue="US" />
      <TextInput source="display_name" />
      <TextInput source="serviceability_note" />
      <BooleanInput source="is_deleted" />
      <BooleanInput source="is_primary" />
    </ZippitySimpleForm>
  </Edit>
);
export const CustomerAddressShow = (props) => (
  <Show
    {...props}
    title={
      <CustomTitle
        title="resources.customer-address.title"
        subTitle="resources.customer-address.subtitle"
      />
    }
  >
    <ZippitySimpleShow>
      <TextField source="created_at" />
      <TextField source="modified_at" />
      <TextField source="customer_address_id" />
      <ReferenceField source="customer_id" reference="customer" link="show">
        <TextField source="email" />
      </ReferenceField>
      <TextField source="tax_rate_percent" />
      <TextField source="address_line_1" />
      <TextField source="address_line_2" />
      <TextField source="city" />
      <TextField source="state" />
      <TextField source="postal_code" />
      <TextField source="country" />
      <TextField source="display_name" />
      <LatLngField source="lat-lng" prefix="" />
      <TextField source="serviceability_note" />
      <BooleanField source="is_deleted" />
      <BooleanField source="is_primary" />
    </ZippitySimpleShow>
  </Show>
);

export const printFullAddress = (address) => {
  if (!address) {
    return '';
  }
  const { address_line_1, address_line_2, city, state, postal_code } = address;
  return `${address_line_1 || ''}${address_line_2 ? ' ' : ''}${address_line_2 ||
    ''}, ${city || ''}, ${state || ''} ${postal_code || ''}`;
};
